// App.js
import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import EnisaPage from './pages/EnisaPage';
import AdvisoryPage from './pages/AdvisoryPage';
import About from './pages/aboutPage';
import Faq from './pages/faq';
import ApiDoc from './pages/apidoc';
import ServiceUnavailable from './pages/ServiceUnavailable';
import { appUrl } from './properties/properties';


function App() {
  const [backendAvailable, setBackendAvailable] = useState(null);

  const checkBackend = useCallback(async () => {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      const response = await fetch(`${appUrl}/lastvulnerabilities`, {
        signal: controller.signal,
      });
      clearTimeout(timeout);
      setBackendAvailable(response.ok);
    } catch {
      setBackendAvailable(false);
    }
  }, []);

  useEffect(() => {
    checkBackend();
  }, [checkBackend]);

  if (backendAvailable === null) {
    return (
      <div className="spinner-container" style={{ minHeight: '100vh' }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (backendAvailable === false) {
    return (
      <Router>
        <ServiceUnavailable onRetry={checkBackend} />
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/homepage" element={<HomePage />} />
        <Route exact path="/search" element={<SearchPage />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/faq" element={<Faq />} />
        <Route path="/enisa/:id" element={<EnisaPage />} />
        <Route path="/vulnerability/:id" element={<EnisaPage />} />
        <Route path="/advisory/:id" element={<AdvisoryPage />} />
        <Route exact path="/apidoc" element={<ApiDoc />} />
      </Routes>
    </Router>
  );
}

export default App;
